/**
 *
 * @param {string} monthCode Month code from 01 to 12
 * @param {string} language Language: "es" or "en"
 * @param {boolean} isLowerCase Determines lowercase of Upper case for returned string
 * @returns String with quarter or month text
 */
export function getMonthText(monthCode, language, isLowerCase) {
  if (monthCode === undefined || monthCode === null) return "--";

  if (monthCode.startsWith("Q") || monthCode.startsWith("T")) {
    return monthsNEW[monthCode][language ?? "es"];
  } else if (monthCode.startsWith("20")) {
    if (language === "en") return monthCode.replaceAll("T", "Q");
    else return monthCode.replaceAll("Q", "T");
  }

  let text = monthsNEW[monthCode][language ?? "es"];

  if (!isLowerCase) text = makeUpperCase(text);

  return text;
}

/**
 *
 * @param {string} string String to make upper case
 * @returns Upper case string
 */
function makeUpperCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const monthsNEW = {
  "01": {
    en: "january",
    es: "enero",
  },
  "02": {
    en: "february",
    es: "febrero",
  },
  "03": {
    en: "march",
    es: "marzo",
  },
  "04": {
    en: "april",
    es: "abril",
  },
  "05": {
    en: "may",
    es: "mayo",
  },
  "06": {
    en: "june",
    es: "junio",
  },
  "07": {
    en: "july",
    es: "julio",
  },
  "08": {
    en: "august",
    es: "agosto",
  },
  "09": {
    en: "september",
    es: "septiembre",
  },
  10: {
    en: "october",
    es: "octubre",
  },
  11: {
    en: "november",
    es: "noviembre",
  },
  12: {
    en: "december",
    es: "diciembre",
  },
  Q1: {
    en: "1st Trimester",
    es: "1er Trimestre",
  },
  Q2: {
    en: "2nd Trimester",
    es: "2do Trimestre",
  },
  Q3: {
    en: "3rd Trimester",
    es: "3er Trimestre",
  },
  Q4: {
    en: "4th Trimester",
    es: "4to Trimestre",
  },
  ALL: {
    en: "annual",
    es: "anual",
  },
};
